import {Injectable} from '@angular/core';
import WebSocketObservable from './websocket';

const CounterUrl = 'wss://chat.goodgame.ru/counter/';

@Injectable()
export class WebsocketService {
  private ws: WebSocketObservable | null;

  constructor() {
    this.ws = new WebSocketObservable(CounterUrl);
    this.ws.on('welcome').subscribe(() => this.onWelcome());

    setInterval(() => this.ping(), 30000);
  }

  private _channel: string;

  set channel(value) {
    this._channel = value;

    if (!this.ws.connected) {
      this.ws.reconnect();
    }
  }

  public on(type) {
    return this.ws.on(type);
  }

  public send(type, data) {
    return this.ws.send(type, data);
  }

  destroy() {
    this.ws.destroy();
  }

  private ping() {
    if (!this._channel || !this.ws) return false;
    this.ws.send('ping', {channel: this._channel, state: 1});
  }

  private onWelcome() {
    this.ws.next({type: 'connected', data: {}});
    this.ping();
  }
}
